// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8298556a","453":"9537af23","455":"c1144c47","806":"8ed3d621","977":"f0cf4c06"}[chunkId] + ".chunk.js";
};